import React, { useEffect, useState } from "react";

const MessageA15 = (props) => {
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    const handleInputChange = (e) => {
      if (e?.detail !== undefined) {
        setIsDisabled(!e.detail.valid);
        return;
      }
      // Legacy fallback for plain InputField (no detail)
      const data = localStorage.getItem("inputValue");
      if (data) {
        try {
          const parsed = JSON.parse(data);
          const hasValue = parsed?.key1?.trim().length > 0;
          const isValid = parsed.isValid !== false;
          setIsDisabled(!(hasValue && isValid));
        } catch {
          setIsDisabled(true);
        }
      } else {
        setIsDisabled(true);
      }
    };

    window.addEventListener("a15InputChange", handleInputChange);
    handleInputChange({});

    return () => {
      window.removeEventListener("a15InputChange", handleInputChange);
    };
  }, []);

  // const checkButton = () => {
  //   let userText = props?.item?.text || "Submit"
  //   const buttonTextOptions = ["Yes", "No", "Submit", "Confirm" ,"Send OTP"];
  
  //   // Check if any of the options are included in userText
  //   if (buttonTextOptions.some(option => userText.includes(option))) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  const checkButton = () => {
    let userText = props?.item?.text;
    const buttonTextOptions = ["Yes", "No", "Submit", "Confirm", "Send OTP", "Got it"];
  
    return buttonTextOptions.includes(userText);
  };


  return (
    <div style={{ marginTop: "10px" }}>
      <button
        disabled={isDisabled}
        className="submit-btn"
      >
        <span
          className={
            !props.disable
              ? "chat-label action-tab "
              : "chat-labelnohover action-tab"
          }
          style={{
            color: props.disable && "grey",
            borderRadius: checkButton() ? "4px" : '44px',
            opacity: isDisabled ? 0.4 : 1,
            cursor: isDisabled ? "not-allowed" : "pointer",
            pointerEvents: isDisabled ? "none" : "auto",
          }}
          id="main-tab1"
          onClick={() => {
            const data = JSON.parse(localStorage.getItem("inputValue"));
            if (!props.disable && !isDisabled) {
              props.handleClick(props.item.code, data);
              props.setTextOnClick(props.item.text);
              setTimeout(() => {
                props?.scrollToBottom?.();
              }, 500);
            }
          }}
        >
          {props.item.text || "Submit"}
        </span>
      </button>
    </div>
  );
};

export default MessageA15;
